import { InformationProps } from "./Information";
import { HierarchyInfoSection } from "../../components/hierarchy-info";
import { filterNonDigits, filterNonDigitsDecimal } from "../../../../helpers";
import { useCreateMpnStore } from "../../context/create/CreateMpnContext";
import { IMpnInformation } from "../../../../types/data.interface";
import { CreateMpnActions } from "../../states/create";
import { CreateMpnActionTypes } from "../../states/create/data";

const ProductPackaging = () => {


  const {state, dispatch} = useCreateMpnStore()

  const handleSkuDataChange = (key: keyof IMpnInformation, e: any, fallBack=null) => {
    if (e) {
      dispatch(
        CreateMpnActions.setStateValue(CreateMpnActionTypes.SET_MPN_DATA, {
          ...state.mpnData,
          [key]: e.hasOwnProperty("target") ? e.target.value : e.value,
        }),
      );
    } else {
      dispatch(
        CreateMpnActions.setStateValue(CreateMpnActionTypes.SET_MPN_DATA, {
          ...state.mpnData,
          tps_product: fallBack,
        }),
      );
    }
    dispatch(
      CreateMpnActions.setStateValue(
        CreateMpnActionTypes.SET_UNSAVED_CHANGES,
        true,
      ),
    );


  };

  return (
    <>
      <div className="card-header my-2 rounded d-flex justify-content-between">
        <h6 className="m-0 text-primary fw-bold">Carton Information</h6>
      </div>

      <div className=" justify-content-between">
        <div className="row align-items-end">
          <div className="col-2">
            <label className="form-label ">
              Standard Pack <span className="red-text fw-bold">*</span>
            </label>
            <div className="d-flex align-items-center">
              <input
                onChange={(e:any) => handleSkuDataChange("stdpk", e)}
                value={state.mpnData.stdpk}
                maxLength={6}
                type="text"
                className="form-control d-inline"
              />
            </div>
          </div>
          <div className="col-3">
            <label className="form-label">
              Standard Pack Gross Weight (kg){" "}
              <span className="red-text fw-bold">*</span>
            </label>
            <div className="d-flex align-items-center">
              <input
                onChange={(e:any) => handleSkuDataChange("stdpk_weight", e)}
                value={state.mpnData.stdpk_weight}
                type="text"
                className="form-control d-inline"
              />
            </div>
          </div>
          <div className="col-3">
            <label className="form-label">Standard Pack Net Weight (kg)</label>
            <div className="d-flex align-items-center">
              <input
                onChange={(e:any) => handleSkuDataChange("cntwgt", e)}
                value={state.mpnData.cntwgt}
                type="text"
                className="form-control d-inline"
              />
            </div>
          </div>
          <div className="col-4">
            <div className="row pb-1 ">
              <div className="col label-3 bottom-border ">
                <label className="form-label ">
                  <strong> Standard Pack Size </strong>
                </label>
              </div>
            </div>
            <div className="row">
              <div className="col-4 label-3">
                <label className="form-label">
                  L (mm) <span className="red-text fw-bold">*</span>
                </label>
                <div className="d-flex align-items-center">
                  <input
                    onChange={(e:any) => handleSkuDataChange("stdpk_length", e)}
                    value={state.mpnData.stdpk_length}
                    maxLength={6}
                    type="text"
                    className="form-control d-inline"
                  />
                </div>
              </div>
              <div className="col-4 label-3">
                <label className="form-label">
                  W (mm) <span className="red-text fw-bold">*</span>
                </label>
                <div className="d-flex align-items-center">
                  <input
                    onChange={(e:any) => handleSkuDataChange("stdpk_width", e)}
                    value={state.mpnData.stdpk_width}
                    maxLength={6}
                    type="text"
                    className="form-control d-inline"
                  />
                </div>
              </div>
              <div className="col-4 label-3">
                <label className="form-label ">
                  H (mm) <span className="red-text fw-bold">*</span>
                </label>
                <div className="d-flex align-items-center">
                  <input
                    onChange={(e:any) => handleSkuDataChange("stdpk_height", e)}
                    value={state.mpnData.stdpk_height}
                    maxLength={6}
                    type="text"
                    className="form-control d-inline"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductPackaging;
